export function OutlineMuroIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 16H21V19.17C21 20.18 20.18 21 19.17 21H11V16Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.31 3H11V21H5.31C4.04 21 3 19.97 3 18.69V5.31C3 4.04 4.03 3 5.31 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 3H19.17C20.18 3 21 3.82 21 4.83V16H11V3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 6V8" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" />
      <path d="M7 11V13" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" />
      <path d="M7 16V18" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" />
      <path d="M16 18V21" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" />
    </svg>
  );
}
